import React, { SFC, ChangeEventHandler } from 'react';
import { uniqueId } from 'lodash';
import classNames from 'classnames';

interface Props {
  checked: boolean;
  disabled?: boolean;
  small?: boolean;
  id?: string;
  name?: string;
  value?: string;
  onChange?: () => void;
}

export const Checkbox: SFC<Props> = ({
  checked,
  small,
  disabled,
  id,
  name,
  value,
  children,
  onChange,
}) => {
  const checkboxId = id ? id : uniqueId('checkbox-id-');
  const checkboxName = name ? name : uniqueId('checkbox-name-');
  const checkboxValue = value ? value : uniqueId('checkbox-value-');
  const onChangeHandler: ChangeEventHandler = () => {
    if (typeof onChange === 'function') {
      onChange();
    }
  };

  return (
    <label
      className={classNames('checkbox-label', {
        ['is-disabled']: disabled,
        ['checkbox-small']: small,
      })}
      htmlFor={checkboxId}
    >
      <input
        type="checkbox"
        checked={checked}
        id={checkboxId}
        name={checkboxName}
        value={checkboxValue}
        disabled={disabled}
        onChange={onChangeHandler}
      />
      <span className="checkbox" />
      {children}
    </label>
  );
};
